exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-09f245a4] tbody td {\n    cursor: pointer;\n}\n[data-v-09f245a4] tbody td td.non-clickable {\n    cursor: auto;\n}\n.container[data-v-09f245a4] {\n    max-width: 100vw;\n}\n", ""]);

// exports
